import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Form, Button, Container, Row, Col, Card } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import WeekSelector from "../weekSelector";
import DriverSelector from "../../components/driverSelector";
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";


const ExtraFundsEdit = () => {
    const { t } = useTranslation();
    const token = localStorage.getItem("token");

    const [formData, setFormData] = useState({
        driver_id: "",
        week_number: null,
        returnVat: "",
        taxesZus: "",
        partner: "",
        accountant: "",
        carRent: "",
        other: "",
        sallary: "",
        otherExpenses: [],
        otherDesc: "",
        refunds: "",
        refundsDesc: "",
        createdAt: new Date().toISOString().slice(0, 10)
    });
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();

    // Функція для отримання списку користувачів
    const fetchUsers = useCallback(async () => {
        try {
            const response = await axios.get("https://godrive.com.pl/api/users");
            const formattedUsers = response.data.map(user => ({
                value: user.id,
                label: `${user.firstName} ${user.lastName}`
            }));
            setUsers(formattedUsers);
        } catch (error) {
            console.error("Error fetching users", error);
        }
    }, []);

    // Функція для отримання даних про додаткові виплати
    const fetchFundById = useCallback(async (fundId) => {
        try {
            const response = await axios.get(`https://godrive.com.pl/api/extraFunds/${fundId}`);
            const fundData = response.data;
    
            console.log("🛠 [Client] Received fundData from server:", fundData);
    
            setFormData((prevFormData) => ({
                ...prevFormData,  // Зберігаємо попередній стан
                ...fundData,  // Оновлюємо новими даними з сервера
                otherExpenses: Array.isArray(fundData.other_expenses) ? fundData.other_expenses : []
            }));
    
            if (fundData.driver_id) {
                setSelectedUser(users.find(user => user.value === fundData.driver_id) || null);
            }
        } catch (error) {
            console.error("❌ Error fetching extra fund", error);
        }
    }, [users]);
    
    useEffect(() => {
        const fetchDefaults = async () => {
            try {
                const response = await axios.get("https://godrive.com.pl/api/settings",
                    {
                        headers: { Authorization: `Bearer ${token}` },
                      }
                );
                const settings = response.data;
    
                setFormData((prev) => ({
                    ...prev,
                    returnVat: prev.returnVat || parseFloat(settings.default_returnVat) || 0,
                    taxesZus: prev.taxesZus || parseFloat(settings.default_taxesZus) || 0,
                    partner: prev.partner || parseFloat(settings.default_partner) || 0,
                    accountant: prev.accountant || parseFloat(settings.default_accountant) || 0,
                    carRent: prev.carRent || parseFloat(settings.default_carRent) || 0,
                    sallary: prev.sallary || parseFloat(settings.default_sallary) || 0,
                    refunds: prev.refunds || parseFloat(settings.default_refunds) || 0,
                  }));
                  
            } catch (error) {
                console.error("❌ Error loading default extra fund settings", error);
            }
        };
    
        if (!id) {
            fetchDefaults();
        }
    }, [id]);
    

    useEffect(() => {
        fetchUsers();
    }, [fetchUsers]);

    useEffect(() => {
        if (id && users.length > 0) {
            fetchFundById(id);
        }
    }, [id, users, fetchFundById]); // Тепер усі залежності додані

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const driverId = queryParams.get("driver_id");
        const week = queryParams.get("week_number");
    
        if (driverId && users.length > 0) {
            const user = users.find(u => u.value === parseInt(driverId));
            if (user) {
                setSelectedUser(user);
                setFormData(prev => ({
                    ...prev,
                    driver_id: user.value,
                    week_number: week || ""
                }));
            }
        }
    }, [users, location.search]);
    
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleAddExpense = () => {
        setFormData({
            ...formData,
            otherExpenses: [...(formData.otherExpenses || []), { amount: "", description: "" }]
        });
    };

    const handleExpenseChange = (index, field, value) => {
        const updatedExpenses = [...formData.otherExpenses];
        updatedExpenses[index][field] = value;
        setFormData({ ...formData, otherExpenses: updatedExpenses });
    };

    const handleRemoveExpense = (index) => {
        const updatedExpenses = formData.otherExpenses.filter((_, i) => i !== index);
        setFormData({ ...formData, otherExpenses: updatedExpenses });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!selectedUser || !selectedUser.value) {
            alert(t("chooseDriverAlert"));
            return;
        }

        const totalOther = formData.otherExpenses.reduce((sum, exp) => sum + (parseFloat(exp.amount) || 0), 0);


        const dataToSend = {
            driver_id: selectedUser ? selectedUser.value : "",
            week_number: formData.week_number || 0,
            returnVat: formData.returnVat ? parseFloat(formData.returnVat) || 0 : 0,
            taxesZus: formData.taxesZus ? parseFloat(formData.taxesZus) || 0 : 0,
            partner: formData.partner ? parseFloat(formData.partner) || 0 : 0,
            accountant: formData.accountant ? parseFloat(formData.accountant) || 0 : 0,
            carRent: formData.carRent ? parseFloat(formData.carRent) || 0 : 0,
            other: totalOther,
            sallary: formData.sallary ? parseFloat(formData.sallary) || 0 : 0,
            otherExpenses: formData.otherExpenses || [], // Ось тут замість JSON.stringify
            refunds: formData.refunds ? parseFloat(formData.refunds) || 0 : 0,
            refundsDesc: formData.refundsDesc || ""
        };

        console.log("Submitting data:", dataToSend);
        try {
            if (id) {
                await axios.put(`https://godrive.com.pl/api/extraFunds/${id}`, dataToSend);
            } else {
                await axios.post("https://godrive.com.pl/api/extraFunds", dataToSend);
            }
            navigate("/admin/driver-extra-funds");
        } catch (error) {
            console.error("Error saving extra fund", error);
        }
    };


    return (
        <Container>
            <h2>{id ? t("edit") : t("add")} {t("extraCosts").toLocaleLowerCase()}</h2>
            <Form onSubmit={handleSubmit}>
                <Row style={{ marginBottom: "20px" }}>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <DriverSelector selectedDriver={selectedUser} setSelectedDriver={setSelectedUser} />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group>
                            <WeekSelector 
                                selectedWeek={formData.week_number} 
                                setSelectedWeek={(week) => setFormData({ ...formData, week_number: week })} 
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                    <Card className="p-3 border bg-light" >
                        <Form.Group>
                            <Form.Label>{t("refunds")} {t("vat")}</Form.Label>
                            <Form.Control type="number" name="returnVat" value={formData.returnVat} onChange={handleChange} />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{t("taxes")} {t("zus")}</Form.Label>
                            <Form.Control type="number" name="taxesZus" value={formData.taxesZus} onChange={handleChange} />
                        </Form.Group>
                        </Card>
                    </Col>
                    <Col md={6}>
                    <Card className="p-3 border bg-light" >
                        <Form.Group>
                            <Form.Label>{t("payment")} {t("partner")}</Form.Label>
                            <Form.Control type="number" name="partner" value={formData.partner} onChange={handleChange} />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{t("accountant")}</Form.Label>
                            <Form.Control type="number" name="accountant" value={formData.accountant} onChange={handleChange} />
                        </Form.Group></Card>
                    </Col>
                </Row>
                <Row style={{ marginBottom: "20px" }}>
                    <Col md={12}>
                        <Form.Group>
                            <Form.Label>{t("carRent")}</Form.Label>
                            <Form.Control type="number" name="carRent" value={formData.carRent} onChange={handleChange} />
                        </Form.Group>
                    </Col>
                </Row>
                <Row style={{ marginBottom: "20px" }}>
                    <Col md={6}>
                    <Card className="p-3 border bg-light " >
                    <Form.Group>
                        <Form.Label>{t("otherCosts")}</Form.Label>
                        
                        {(formData.otherExpenses || []).map((expense, index) => (
                            <div key={index} className="d-flex mb-2">
                                <Form.Control
                                    type="number"
                                    placeholder={t("value")}
                                    value={expense.amount}
                                    onChange={(e) => handleExpenseChange(index, "amount", e.target.value)}
                                    className="me-2"
                                />
                                <Form.Control
                                    type="text"
                                    placeholder={t("description")}
                                    value={expense.description}
                                    onChange={(e) => handleExpenseChange(index, "description", e.target.value)}
                                    className="me-2"
                                />
                                <Button variant="danger" onClick={() => handleRemoveExpense(index)}>-</Button>
                            </div>
                        ))}
                        <Button variant="success" onClick={handleAddExpense}>+ {t("add")}</Button>
                    </Form.Group>

                        <Form.Group>
                            <Form.Label>{t("sallary")} ({t("accountant").toLocaleLowerCase()})</Form.Label>
                            <Form.Control type="number" name="sallary" value={formData.sallary} onChange={handleChange} />
                        </Form.Group>
                        </Card>
                        
                    </Col>
                    <Col md={6}>
                    <Card className="p-3 border bg-light " >
                        <Form.Group>
                            <Form.Label>{t("refunds")}</Form.Label>
                            <Form.Control type="number" name="refunds" value={formData.refunds} onChange={handleChange} />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{t("refunds")} {t("description").toLocaleLowerCase()}</Form.Label>
                            <Form.Control type="text" name="refundsDesc" value={formData.refundsDesc} onChange={handleChange} />
                        </Form.Group></Card>
                    </Col>
                </Row>
                <Button type="submit">{id ? t("save") : t("add")}</Button>
            </Form>
        </Container>
    );
};

export default ExtraFundsEdit;
